module.exports = __webpack_public_path__ + "img/symbol_3.06342880.png";